import { render, staticRenderFns } from "./resetLogin.vue?vue&type=template&id=65caa924"
import script from "./resetLogin.vue?vue&type=script&lang=js"
export * from "./resetLogin.vue?vue&type=script&lang=js"
import style0 from "./resetLogin.vue?vue&type=style&index=0&id=65caa924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports